import { render, staticRenderFns } from "./product_type.vue?vue&type=template&id=f3b0fb2c&"
import script from "./product_type.vue?vue&type=script&lang=js&"
export * from "./product_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports